import { COMMUNITY_SECTION_LINK } from 'constants/constants';
import { navigateTo } from 'helpers/url';
import i18n from 'i18n/config';
import CommunityIcon from 'styles/assets/icons/CommunityIcon';
import Box from 'UIKit/Box';

import styles from './style.module.scss';

const CommunityText = i18n.t('headerFooter:header.sideMenu.communityText');

const CommunitySection = () => {
  const handleClick = () => {
    navigateTo(COMMUNITY_SECTION_LINK, '_blank');
  };

  return (
    <Box
      flex="flex"
      alignItems="center"
      onClick={handleClick}
      className={styles.communityContainer}
      data-testid="SideMenuCommunitySection"
    >
      <Box>
        <CommunityIcon />
      </Box>
      <Box className={styles.communityText}>{CommunityText}</Box>
    </Box>
  );
};

export { CommunitySection };
